export const useRecaptcha = () => {
  const { locale } = useI18n()
  const recaptchaValid = ref(true)
  const recaptchaRendered = ref(false)
  const config = useRuntimeConfig().public
  const captcha = config.appEnv === 'production' ? config.recaptcha : (config.recaptchaTest || config.recaptcha)

  const waitForElm = (selector: string): Promise<Element | null> => {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector))
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          observer.disconnect()
          resolve(document.querySelector(selector))
        }
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })
    })
  }

  const loadCaptcha = async () => {
    const recaptchaContainer = await waitForElm('#recaptcha')
    // fix a problem when, loaded more than one time
    recaptchaValid.value = true
    if (recaptchaContainer?.querySelector('iframe')) return

    if (!recaptchaRendered.value) {
      window.grecaptcha.ready(() => {
        recaptchaRendered.value = true
        window.grecaptcha.render(
          'recaptcha',
          {
            sitekey: captcha,
            callback: (response: string) => setStatusOnRecaptcha(response === ''),
            hl: locale.value,
            'expired-callback': () => setStatusOnRecaptcha(true),
          },
        )
      })
    }
  }

  const setStatusOnRecaptcha = (status: boolean) => {
    recaptchaValid.value = status
  }

  onMounted(() => {
    const scriptExists = !!document.querySelector('script[src*="recaptcha/api.js"]')
    ; (window as any).recaptchaLoaded = () => {
      loadCaptcha()
    }

    if (!scriptExists) {
      const script = document.createElement('script')
      script.src = `https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit&hl=${locale.value}`
      document.body.appendChild(script)
    } else if (typeof window.grecaptcha !== 'undefined') {
      loadCaptcha()
    }
  })

  watch(locale, () => {
    loadCaptcha()
  })

  return {
    recaptchaValid,
    loadCaptcha,
  }
}
